/**
 * Sorts strings alphabetically, handling case insensitivity
 * @param {string | null | undefined} aString
 * @param {string | null | undefined} bString
 * @param {string} sortOrder - 'asc' or 'desc'
 * @returns {number}
 */
export default function nameSort(aString, bString, sortOrder = 'asc') {
  // Handle undefined, null, or empty strings
  if (!aString && !bString) return 0;
  if (!aString) return sortOrder === 'asc' ? 1 : -1;
  if (!bString) return sortOrder === 'asc' ? -1 : 1;

  // Convert to strings in case we get numbers or other types
  const a = String(aString).toLowerCase();
  const b = String(bString).toLowerCase();

  // Use the built-in localeCompare for proper string comparison
  const comparisonResult = a.localeCompare(b);

  // Return the result based on the sort order
  return sortOrder === 'asc' ? comparisonResult : -comparisonResult;
}
